/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UtenteAddFilieraPermissionDTO
 */
export interface UtenteAddFilieraPermissionDTO {
    /**
     * 
     * @type {number}
     * @memberof UtenteAddFilieraPermissionDTO
     */
    idFiliera?: number;
    /**
     * 
     * @type {string}
     * @memberof UtenteAddFilieraPermissionDTO
     */
    permissionId?: string | null;
}

/**
 * Check if a given object implements the UtenteAddFilieraPermissionDTO interface.
 */
export function instanceOfUtenteAddFilieraPermissionDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UtenteAddFilieraPermissionDTOFromJSON(json: any): UtenteAddFilieraPermissionDTO {
    return UtenteAddFilieraPermissionDTOFromJSONTyped(json, false);
}

export function UtenteAddFilieraPermissionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtenteAddFilieraPermissionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFiliera': !exists(json, 'idFiliera') ? undefined : json['idFiliera'],
        'permissionId': !exists(json, 'permissionId') ? undefined : json['permissionId'],
    };
}

export function UtenteAddFilieraPermissionDTOToJSON(value?: UtenteAddFilieraPermissionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFiliera': value.idFiliera,
        'permissionId': value.permissionId,
    };
}

